var createCache = function createCache(cache) {
  if (cache === void 0) {
    cache = {};
  }

  return {
    _cache: cache,
    get: function get(experiments) {
      var hasAllRequestedExperimentsCached = experiments.every(function (experimentName) {
        return cache[experimentName] !== undefined;
      });

      if (!hasAllRequestedExperimentsCached) {
        return null;
      }

      return experiments.reduce(function (obj, experimentName) {
        obj[experimentName] = cache[experimentName];
        return obj;
      }, {});
    },
    set: function set(experiments) {
      Object.keys(experiments).forEach(function (experimentName) {
        cache[experimentName] = experiments[experimentName];
      });
    },
    missing: function missing(experiments) {
      return experiments.filter(function (experimentName) {
        return cache[experimentName] === undefined;
      });
    },
    toJSON: function toJSON() {
      return JSON.stringify(cache);
    }
  };
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o) {
  var i = 0;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  i = o[Symbol.iterator]();
  return i.next.bind(i);
}

var FALLBACK_VARIANT = 'control';
var query = "\n  query($experiments: [String!]!, $trackingId: String!) {\n    assignments(experiments: $experiments, trackingId: $trackingId) {\n      experiment\n      variant\n      holdout\n    }\n  }\n";

var fallbackAssignments = function fallbackAssignments(experiments) {
  return formatExperiments(experiments.map(function (experiment) {
    return {
      experiment: experiment,
      variant: FALLBACK_VARIANT,
      isFallback: true
    };
  }));
};

var formatExperiments = function formatExperiments(assignments) {
  return assignments.reduce(function (obj, _ref) {
    var experiment = _ref.experiment,
        variant = _ref.variant,
        isFallback = _ref.isFallback;
    obj[experiment] = {
      variant: variant,
      isFallback: isFallback
    };
    return obj;
  }, {});
};

var fetchExperiments = function fetchExperiments(_ref2) {
  var experiments = _ref2.experiments,
      trackingId = _ref2.trackingId,
      host = _ref2.host;

  try {
    return Promise.resolve(fetch(host + "/graphql", {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: query,
        variables: {
          experiments: experiments,
          trackingId: trackingId
        }
      })
    })).then(function (response) {
      return response.ok ? Promise.resolve(response.json()).then(function (_ref3) {
        var data = _ref3.data;
        if (!data) return fallbackAssignments(experiments);
        var assignments = data.assignments.map(function (assignment) {
          return _extends(_extends({}, assignment), {}, {
            isFallback: assignment.holdout || false
          });
        });
        var returnedExperiments = new Set(assignments.map(function (_ref4) {
          var experiment = _ref4.experiment;
          return experiment;
        }));
        var missingExperiments = [];
        experiments.forEach(function (experiment) {
          if (!returnedExperiments.has(experiment)) missingExperiments.push({
            experiment: experiment,
            variant: FALLBACK_VARIANT,
            isFallback: true
          });
        });
        return formatExperiments(assignments.concat(missingExperiments));
      }) : fallbackAssignments(experiments);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var ApiEndpoint;

(function (ApiEndpoint) {
  ApiEndpoint["SANDBOX"] = "https://experiments.dev1.sandbox-ezcater.com";
  ApiEndpoint["STAGING"] = "https://experiments.staging-ezcater.com";
  ApiEndpoint["PRODUCTION"] = "https://experiments.ezcater.com";
})(ApiEndpoint || (ApiEndpoint = {}));

var ApiEndpoint$1 = ApiEndpoint;

var Environment;

(function (Environment) {
  Environment["DEVELOPMENT"] = "development";
  Environment["PRODUCTION"] = "production";
  Environment["SANDBOX"] = "sandbox";
  Environment["STAGING"] = "staging";
})(Environment || (Environment = {}));

var Environment$1 = Environment;

var _HOST_BY_ENVIRONMENT;
var HOST_BY_ENVIRONMENT = (_HOST_BY_ENVIRONMENT = {}, _HOST_BY_ENVIRONMENT[Environment$1.DEVELOPMENT] = 'localhost', _HOST_BY_ENVIRONMENT[Environment$1.SANDBOX] = 'sandbox-ezcater.com', _HOST_BY_ENVIRONMENT[Environment$1.STAGING] = 'staging-ezcater.com', _HOST_BY_ENVIRONMENT);
var environments = [Environment$1.DEVELOPMENT, Environment$1.SANDBOX, Environment$1.STAGING];

var getEnvironment = function getEnvironment() {
  for (var _iterator = _createForOfIteratorHelperLoose(environments), _step; !(_step = _iterator()).done;) {
    var environment = _step.value;
    var host = HOST_BY_ENVIRONMENT[environment];

    if (window.location.origin.indexOf(host) !== -1) {
      return environment;
    }
  }

  return Environment$1.PRODUCTION;
};

var _ENDPOINT_BY_ENVIRONM;
var ENDPOINT_BY_ENVIRONMENT = (_ENDPOINT_BY_ENVIRONM = {}, _ENDPOINT_BY_ENVIRONM[Environment$1.DEVELOPMENT] = ApiEndpoint$1.SANDBOX, _ENDPOINT_BY_ENVIRONM[Environment$1.STAGING] = ApiEndpoint$1.STAGING, _ENDPOINT_BY_ENVIRONM[Environment$1.SANDBOX] = ApiEndpoint$1.SANDBOX, _ENDPOINT_BY_ENVIRONM[Environment$1.PRODUCTION] = ApiEndpoint$1.PRODUCTION, _ENDPOINT_BY_ENVIRONM);

var getApiEndpoint = function getApiEndpoint() {
  var environment = getEnvironment();
  return ENDPOINT_BY_ENVIRONMENT[environment];
};

var ExperimentsClient = /*#__PURE__*/function () {
  function ExperimentsClient(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        host = _ref.host,
        cache = _ref.cache;

    this.cache = cache || createCache();
    this.host = host || getApiEndpoint();
  }

  var _proto = ExperimentsClient.prototype;

  _proto.get = function get(_ref2) {
    var experiments = _ref2.experiments,
        _ref2$trackingId = _ref2.trackingId,
        trackingId = _ref2$trackingId === void 0 ? '' : _ref2$trackingId;

    try {
      var _this2 = this;

      var cachedExperiments = _this2.cache.get(experiments);

      if (cachedExperiments) return Promise.resolve(cachedExperiments);

      var missingExperiments = _this2.cache.missing(experiments);

      return Promise.resolve(fetchExperiments({
        host: _this2.host,
        experiments: missingExperiments,
        trackingId: trackingId
      })).then(function (resolvedExperiments) {
        _this2.cache.set(resolvedExperiments);

        return _this2.cache.get(experiments) || {};
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return ExperimentsClient;
}();

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var TYPE_NAME = 'Assignment';

var createExperimentsResolver = function createExperimentsResolver(clientProps) {
  if (clientProps === void 0) {
    clientProps = {};
  }

  var client = new ExperimentsClient(clientProps);
  return {
    Query: {
      experimentAssignments: function experimentAssignments(_, _ref) {
        var experiments = _ref.experiments,
            trackingId = _ref.trackingId;

        try {
          return Promise.resolve(_catch(function () {
            return Promise.resolve(client.get({
              experiments: experiments,
              trackingId: trackingId
            })).then(function (data) {
              return experiments.map(function (experimentName) {
                return {
                  experiment: experimentName,
                  variant: data[experimentName].variant,
                  isFallback: data[experimentName].isFallback,
                  __typename: TYPE_NAME
                };
              });
            });
          }, function (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return null;
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }
  };
};

export { ExperimentsClient, createCache, createExperimentsResolver };
//# sourceMappingURL=experiments-js.esm.js.map
